<template>
  <modal>
    <div class="modal-content">
      <img src="@/assets/images/btn-close.svg" @click="$emit('closeChangeRoute')" class="btn-close">
      <h2 class="message text-center text-lg font-bold mb-2">{{ $t('tour_change_route') }}</h2>
      <ul class="course">
        <li v-for="(route, index) in routes" v-bind:key="index">
          <template v-if="route.serializeData !== undefined">
            <div class="summary">
              <div class="flex justify-between items-end px-2 pb-1 font-semibold">
                <div class="flex-none pr-2 w-8">
                  <p class="flex justify-center items-center p-1 w-6 h-6 bg-link rounded-full text-white">{{ String(index + 1) }}</p>
                </div>
                <div class="flex-1 text-right">
                  {{ $t('tour_fare') }}<span class="text-xl leading-none">{{ getTotalFareAndCharge(route).toLocaleString() }}</span>{{ $t('tour_yen') }}
                </div>
              </div>
            </div>
            <div class="route mb-6">
              <route :route="route" :editable="false" />
              <div class="m-2 mb-0 text-center">
                <a class="mx-auto button-primary px-6 inline-block button-is-small" @click="setRoute(index)">
                  {{ $t('tour_change_route_submit') }}
                </a>
              </div>
            </div>
          </template>
        </li>
      </ul>
    </div>
    <div class="modal-button flex justify-between">
      <a @click="$emit('closeChangeRoute')" class="button-secondary block w-full button-is-small">{{ $t('tour_change_route_cancel') }}</a>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Modal from "../atoms/Modal"
import Route from "../molecules/Route"
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    Modal,
    Route
  },
  props: {
    changeRouteIndex: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      loading: true
    }
  },
  mounted () {
    const routes = this.$store.getters['routes/getAll']
    const route = routes[this.changeRouteIndex]
    const condition = this.$store.getters['condition/getOptions']
    let p = {
      from: this.$store.getters['destinations/getDestination'](this.changeRouteIndex - 1),
      to: this.$store.getters['destinations/getDestination'](this.changeRouteIndex),
      searchType: route.searchType,
      time: moment(route.searchDatetime),
      taxiDistance: condition.taxiDistance,
      sort: condition.sort
    }
    // 最初の目的地であればfromに出発駅をセットしてその間の経路を検索
    if (!p.from) {
      const departure = this.$store.getters['destinations/getDepatureStation']
      p = { ...p, from: departure }
    }
    // 最後の目的地であればtoに到着駅をセットしてその間の経路を検索
    if (!p.to) {
      const arrival = this.$store.getters['destinations/getArrivalStation']
      p = { ...p, to: arrival }
    }
    this.$store.dispatch('routes/searchRouteAll', p)
  },
  methods: {
    setRoute: function (index) {
      const p = {
        index: this.changeRouteIndex,
        serializeData: this.routes[index].serializeData
      }
      this.$store.dispatch('routes/setSerializeData', p)
      this.$store.dispatch('routes/search')
      this.$emit('closeChangeRoute')
    },
    closeChangeRoute: function () {
      this.$emit('closeChangeRoute')
    },
    getTotalFareAndCharge: function (route) {
      const price = route.course.Ticket.Price.find(p => p.id == "normal")
      return (parseInt(price.fareSummary, 10) + parseInt(price.chargeSummary, 10))
    }
  },
  computed: {
    ...mapGetters({
      routes: 'routes/getRouteList'
    }),
  }
}
</script>
